import { useCallback, useEffect, useState } from "react";
import ListBox from "./Components/ListBox";
import groupService from "./Shared/GroupService";
import { idGroupBR } from "../../../Utils/const";
import CircularProgress from '@mui/material/CircularProgress';

const Group = () => {
    const boxGroupId = localStorage.getItem("group_id");
    const [group, setGroup] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const loadBoxGroup = useCallback(() => {
        if (!boxGroupId) return;

        setIsLoading(true)
        groupService.getOneBoxGroup(boxGroupId)
            .then(res => {
                setGroup(res.data)
            })
            .catch(error => console.log(error))
            .finally(() => setIsLoading(false))
    }, [boxGroupId]);

    useEffect(() => {
        loadBoxGroup()
    }, [loadBoxGroup])

    return <>
        {
            idGroupBR.includes(boxGroupId) ?
                <ListBox group={group} boxes={group.boxs || []} isLoading={isLoading} onBoxUpdated={loadBoxGroup} />
                :
                <div className="w-full text-center pt-100">
                    <CircularProgress color="primary" size="10rem" />
                </div>
        }
    </>
}

export default Group;